import { PhaseView } from './PhaseView'
export function Phase1View() {
  return <PhaseView phase="p1" />
}
